// script pulled from https://app.segment.com/digitalocean/sources/front-end/overview
export function initializeSegment(): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const analytics = ((window as any).analytics =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).analytics || []);
  if (!analytics.initialize) {
    if (analytics.invoked) {
      window.console.error('Segment snippet included twice.');
    } else {
      analytics.invoked = !0;
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on'
      ];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      analytics.factory = (t: any) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (...args: any) => {
          const e = Array.prototype.slice.call(args);
          e.unshift(t);
          analytics.push(e);
          return analytics;
        };
      };
      for (const method of analytics.methods) {
        analytics[method] = analytics.factory(method);
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      analytics.load = (t: any, e: any) => {
        const n = document.createElement('script');
        n.type = 'text/javascript';
        n.async = !0;
        n.src =
          'https://segment.digitalocean.com/analytics.js/v1/' +
          t +
          '/analytics.min.js';
        const a = document.getElementsByTagName('script')[0];
        a?.parentNode?.insertBefore(n, a);
        analytics._loadOptions = e;
      };
      analytics._writeKey = 'lisvh8pnfj';
      analytics.SNIPPET_VERSION = '4.15.3';
      analytics.load('lisvh8pnfj');
      /* 
        Since sending pageviews is part of the segment snippet,
        we're directly excluding the password reset page since
        the token is part of the pathname directly.
        This behaviour should be carried over when updating this script.
      */
      if (!window.location.pathname.match(/^\/password_resets.*/)) {
        analytics.page();
      }
    }
  }
}

export default initializeSegment;
